"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _clsx = _interopRequireDefault(require("clsx"));
var _Typography = _interopRequireDefault(require("../../Typography"));
var _excluded = ["className", "kind", "level", "underline"];
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}
function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};
  var target = _objectWithoutPropertiesLoose(source, excluded);
  var key, i;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }
  return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }
  return target;
}
var styles = {
  "captionText": "jfmU9O",
  "underline": "A1SnqP",
  "caption": "Bkr9-8",
  "lighter": "kOjiOv",
  "inverseLighter": "eVXQbS"
};
var CaptionText = function CaptionText(_ref) {
  var className = _ref.className,
    kind = _ref.kind,
    level = _ref.level,
    underline = _ref.underline,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/_react["default"].createElement(_Typography["default"], _extends({}, props, {
    className: (0, _clsx["default"])(className, styles.captionText, styles[kind], level === 'caption' && styles.caption, underline && styles.underline),
    kind: kind,
    level: level
  }));
};
CaptionText.propTypes = process.env.NODE_ENV !== "production" ? {
  className: _propTypes["default"].string,
  kind: _propTypes["default"].oneOf(['lighter', 'inverseLighter']),
  level: _propTypes["default"].oneOf(['body', 'caption']),
  underline: _propTypes["default"].bool
} : {};
var _default = exports["default"] = CaptionText;